import React, { useEffect, useState } from 'react';
import { useLocation } from 'wouter';

import CloseSvg from '@/components/common/CloseSvg';
import { useAuthenticated } from '@/components/shopping_bag/hooks/useAuthenticated';

import { AccordionButton } from '../Components/Accordion';
import { CardTypeSelector } from '../Components/CardTypeSelector';
import { FormGiftCard } from '../Components/FormGiftCard';
import { ManagePayment } from '../Components/ManagePayment';
import { usePayment } from '../Context/PaymentContext';
import { useAccount } from '../hooks/useAccount';
export const Payment = () => {
    const {
        accordionStates,
        setAccordionStates,
        setMode,
        showNotification,
        setShowNotification,
        showWarning,
        setShowWarning,
    } = usePayment();
    const isAuthenticated = useAuthenticated();
    const { data, isFetching, error } = useAccount(isAuthenticated);
    const [location] = useLocation();
    useEffect(() => {
        // Reset the state when the route changes
        setAccordionStates([
            { id: 0, isOpen: true },
            { id: 1, isOpen: false },
            { id: 2, isOpen: false },
        ]);
        setMode('view');
    }, [location]);

    return (
        <>
            <div className="payment px-5 md:px-0">
                <h1 className="m-0 text-base font-bold text-[#1a1a1a] md:text-2xl md:leading-8">
                    Manage payment options
                </h1>
                {showWarning && (
                    <div className="notification__red">
                        <button
                            className="dialog__card__close-button"
                            type="button"
                            onClick={() => {
                                setShowWarning(false);
                            }}
                        >
                            <span className="visually-hidden">close</span>
                            <CloseSvg />
                        </button>
                        <img
                            src="/App_Assets/public/icon-exclamation-black.svg"
                            alt="exclamation-icon"
                            className="exclamation-img"
                        />
                        <div>
                            <strong>Important!</strong> Please call 1-833-583-0080 for any required changes to your
                            credit card for existing orders, including ones with remaining monthly installments.
                        </div>
                    </div>
                )}

                {showNotification && (
                    <div className="creditcard__success">
                        <button
                            className="dialog__card__close-button"
                            type="button"
                            onClick={() => {
                                setShowNotification(false);
                            }}
                        >
                            <span className="visually-hidden">close</span>
                            <CloseSvg />
                        </button>
                        <img
                            src="/App_Assets/public/icon-exclamation-black.svg"
                            alt="exclamation-icon"
                            className="exclamation-img"
                        ></img>
                        <div>
                            <strong>The credit card has been added to your account.</strong> If this card needs to be
                            used for any existing orders that haven&apos;t shipped or have remaining monthly
                            installments, please call <span style={{ whiteSpace: 'nowrap' }}>1-833-583-0080.</span>
                        </div>
                    </div>
                )}

                {data.CreditCards.length > 0 && (
                    <div className="payment__manage  my-5 bg-[#f8f8f8] px-5 py-3">
                        <AccordionButton
                            title="Manage credit cards"
                            ariaControls="paymentAccordion1"
                            id={0}
                            setMode={setMode}
                            stateFromParent={accordionStates[0].isOpen}
                            accordionStates={accordionStates}
                            setAccordionStates={setAccordionStates}
                        >
                            <ManagePayment />
                        </AccordionButton>
                    </div>
                )}

                <div className="payment__add  my-5 bg-[#f8f8f8] px-5 py-3">
                    <AccordionButton
                        title="Add a credit card"
                        ariaControls="paymentAccordion2"
                        id={1}
                        setMode={setMode}
                        stateFromParent={accordionStates[1].isOpen}
                        accordionStates={accordionStates}
                        setAccordionStates={setAccordionStates}
                    >
                        <CardTypeSelector />
                    </AccordionButton>
                </div>
                <div className="payment__giftcard  my-5 bg-[#f8f8f8] px-5 py-3">
                    <AccordionButton
                        title="Check gift card balance"
                        ariaControls="paymentAccordion3"
                        id={2}
                        setMode={setMode}
                        stateFromParent={accordionStates[2].isOpen}
                        accordionStates={accordionStates}
                        setAccordionStates={setAccordionStates}
                    >
                        <FormGiftCard />
                    </AccordionButton>
                </div>
            </div>
        </>
    );
};
